/** 与后端 IpeModuleCode 保持一致：模块目录；单价由 IPE 定价 API 提供，不在此硬编码 */
export const IPE_MODULE_CATALOG = [
  { code: 'GOODS_COMPOSITE', navId: 'goods', label: '主图创作', billingUnit: '张' },
  { code: 'TITLE_EXTRACT', navId: 'titles', label: '标题提取', billingUnit: '张' },
  { code: 'IMAGE_CROP', navId: 'imageCrop', label: '图案裁剪', billingUnit: '张' },
  { code: 'IMAGE_ENHANCE', navId: 'imageEnhance', label: '超分提质', billingUnit: '张' },
  { code: 'SMART_CUTOUT', navId: 'smartCutout', label: '智能抠图', billingUnit: '张' },
  { code: 'STAMP_EXTRACT', navId: 'stampExtract', label: '印花提取', billingUnit: '张' },
  { code: 'IMAGE_FISSION', navId: 'imageFission', label: '图片裂变', billingUnit: '张' },
  { code: 'PATTERN_FISSION', navId: 'patternFission', label: '图案裂变', billingUnit: '张' },
  { code: 'IMG2IMG', navId: 'img2img', label: '万能改图', billingUnit: '张' },
  { code: 'AI_OUTPAINT', navId: 'aiOutpaint', label: 'AI扩图', billingUnit: '张' },
  { code: 'AI_TEXT_TO_IMAGE', navId: 'aiTextToImage', label: '文生图', billingUnit: '张' },
  { code: 'AI_COPYWRITING', navId: 'aiCopywriting', label: 'AI文案', billingUnit: '张' },
  { code: 'VIDEO_GENERATE', navId: 'videos', label: '图生视频', billingUnit: '张' },
  { code: 'TEXT_TO_VIDEO', navId: 'textToVideo', label: '文生视频', billingUnit: '张' },
  { code: 'MODEL_TRY_ON', navId: 'modelTryOn', label: '模特试衣', billingUnit: '张' },
  { code: 'MODEL_HANDHELD', navId: 'modelHandheld', label: '手持商品', billingUnit: '张' },
  { code: 'MODEL_POSE_FISSION', navId: 'modelPoseFission', label: '姿势裂变', billingUnit: '张' },
  { code: 'MODEL_UNIVERSAL_WEAR', navId: 'modelUniversalWear', label: '万物穿戴', billingUnit: '张' },
  { code: 'POD_PRODUCT_DESIGN', navId: 'podProductDesign', label: 'POD商品设计', billingUnit: '张' },
  { code: 'INFRINGEMENT_DETECTION', navId: 'infringementDetection', label: '侵权检测', billingUnit: '张' },
  { code: 'LISTING_TEMPLATE', navId: 'imageTemplates', label: '套图模版', billingUnit: '次' },
  { code: 'LISTING_PUBLISH', navId: 'listingTemplates', label: '刊登模板', billingUnit: '次' },
  { code: 'PLATFORM_SHOP', navId: 'platformShops', label: '店铺新增', billingUnit: '次' },
  { code: 'SOURCING_CAPTURE', navId: 'sourcingHub', label: '插件采集', billingUnit: '免费' },
  { code: 'IMAGE_COLLECTION', navId: 'imageCollection', label: '素材采集', billingUnit: '免费' },
  { code: 'WORKFLOW_RUN', navId: 'ipeWorkflow', label: '工作流', billingUnit: '按步骤' },
  { code: 'IMAGE_SPACE', navId: 'imageSpace', label: '图片空间批量', billingUnit: '免费' },
];

/** @deprecated 使用 IPE_MODULE_CATALOG；保留别名避免旧引用报错 */
export const IPE_MODULE_CREDITS = IPE_MODULE_CATALOG;

let runtimeModuleCredits = null;

const MODULE_CREDITS_UPDATED_EVENT = 'ipe:module-credits-updated';

function notifyModuleCreditsUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MODULE_CREDITS_UPDATED_EVENT));
  }
}

/** 由工作台/账号中心加载后注入，与 Admin 定价实时同步 */
export function setRuntimeModuleCredits(modules) {
  if (!Array.isArray(modules) || modules.length === 0) {
    runtimeModuleCredits = null;
    notifyModuleCreditsUpdated();
    return;
  }
  runtimeModuleCredits = modules.map((row) => {
    const billingUnit = row.billingUnit || '张';
    const nonBillable = billingUnit === '免费' || billingUnit === '按步骤';
    const resolutionPrices = normalizeResolutionPrices(
      row.resolutionPrices,
      nonBillable ? 0 : Number(row.creditCost ?? row.pointsPerCall ?? 0),
    );
    return {
      code: row.code,
      navId: row.navId,
      label: row.label,
      creditCost: nonBillable ? 0 : Number(row.creditCost ?? row.pointsPerCall ?? 0),
      billingUnit,
      supportsResolutionPricing: row.supportsResolutionPricing === true
        || row.code === 'VIDEO_GENERATE'
        || row.code === 'TEXT_TO_VIDEO'
        || Boolean(resolutionPrices),
      resolutionPrices: resolutionPrices || undefined,
    };
  });
  notifyModuleCreditsUpdated();
}

const VIDEO_RESOLUTION_TIERS = ['480P', '720P', '1080P'];
const DEFAULT_VIDEO_RESOLUTION = '720P';

function normalizeResolutionPrices(raw, fallback = 0) {
  if (!raw || typeof raw !== 'object') return null;
  const base = Number.isFinite(Number(fallback)) ? Math.max(0, Number(fallback)) : 0;
  const out = {};
  let hasAny = false;
  VIDEO_RESOLUTION_TIERS.forEach((tier) => {
    const n = Number(raw[tier] ?? raw[tier.toLowerCase()]);
    if (Number.isFinite(n) && n >= 0) {
      out[tier] = n;
      hasAny = true;
    } else {
      out[tier] = base;
    }
  });
  return hasAny ? out : null;
}

function normalizeVideoResolutionKey(value) {
  const raw = String(value || '').trim().toUpperCase();
  if (VIDEO_RESOLUTION_TIERS.includes(raw)) return raw;
  if (raw === 'HD') return '1080P';
  if (raw === 'STANDARD') return '720P';
  return DEFAULT_VIDEO_RESOLUTION;
}

/** 供 React Hook 订阅定价刷新事件 */
export const IPE_MODULE_CREDITS_UPDATED_EVENT = MODULE_CREDITS_UPDATED_EVENT;

export function getModuleCreditsList() {
  return runtimeModuleCredits?.length ? runtimeModuleCredits : IPE_MODULE_CATALOG;
}

/** IPE豆说明页不展示的入口（管理类、素材中心、我的空间等） */
const CREDIT_CATALOG_EXCLUDE_NAV_IDS = new Set([
  'accountCenter',
  'orderCenter',
  'teamManagement',
  'downloadCenter',
  'systemMaterialLibrary',
  'imageSpace',
  'spaceFavorites',
  'spaceTrash',
]);

/**
 * 工作台功能 → 计费模块（navId）
 * 各入口默认按自身 navId 定价；仅别名/兼容入口映射到主模块
 */
const NAV_BILLING_REF = {
  fundingWorkflow: 'ipeWorkflow',
  ipeWorkflowTasks: 'ipeWorkflow',
  imageCollection: 'sourcingHub',
};

function isNonBillableUnit(billingUnit) {
  return billingUnit === '免费' || billingUnit === '按步骤';
}

function resolveCreditCost(row, options = {}) {
  if (!row) return 0;
  if (isNonBillableUnit(row.billingUnit)) return 0;
  const resolution = options.resolution != null
    ? normalizeVideoResolutionKey(options.resolution)
    : null;
  if (resolution && row.resolutionPrices && typeof row.resolutionPrices === 'object') {
    const n = Number(row.resolutionPrices[resolution]);
    if (Number.isFinite(n) && n >= 0) return n;
  }
  return Number(row.creditCost ?? row.pointsPerCall ?? 0) || 0;
}

export function formatCreditAmount(value) {
  const n = Number(value) || 0;
  if (Number.isInteger(n)) return n.toLocaleString('en-US');
  return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function creditCostForNav(navId, options = {}) {
  const row = resolveCreditRow(navId);
  if (!row) return null;
  if (isNonBillableUnit(row.billingUnit)) return null;
  const cost = resolveCreditCost(row, options);
  if (cost <= 0) return null;
  return cost;
}

export function creditMetaForNav(navId) {
  return resolveCreditRow(navId);
}

function resolveCreditRow(navId) {
  const modules = getModuleCreditsList();
  const direct = modules.find((m) => m.navId === navId);
  if (direct) return direct;
  const refNavId = NAV_BILLING_REF[navId];
  if (refNavId) {
    return modules.find((m) => m.navId === refNavId) || null;
  }
  return null;
}

/** 任务创建弹窗 mode → 计费 navId */
export function creditNavIdForTaskCreateMode(mode) {
  const map = {
    goods: 'goods',
    titles: 'titles',
    image: 'imageCrop',
    imageCrop: 'imageCrop',
    imageEnhance: 'imageEnhance',
    smartCutout: 'smartCutout',
    stampExtract: 'stampExtract',
    imageFission: 'imageFission',
    patternFission: 'patternFission',
    img2img: 'img2img',
    videos: 'videos',
    textToVideo: 'textToVideo',
    modelTryOn: 'modelTryOn',
  };
  return map[mode] || null;
}

/**
 * 操作前提示文案（按张计费模块在确认时按图片数累计）
 */
export function buildCreditActionHint(navId, imageCount = 1, options = {}) {
  const meta = creditMetaForNav(navId);
  if (!meta) return null;
  const billingUnit = meta.billingUnit || '张';
  if (isNonBillableUnit(billingUnit)) {
    if (billingUnit === '按步骤') return '按工作流所含步骤逐步扣费';
    return '该功能免费';
  }
  const unit = resolveCreditCost(meta, options);
  if (unit <= 0) return null;
  const n = Math.max(1, Number(imageCount) || 1);
  const resolution = options.resolution != null
    ? normalizeVideoResolutionKey(options.resolution)
    : null;
  const resolutionHint = resolution ? ` · ${resolution}` : '';
  if (billingUnit === '张' && n > 1) {
    return `确认后将消耗 ${formatCreditAmount(unit * n)} IPE豆（${formatCreditAmount(unit)} IPE豆/张 × ${n} 张${resolutionHint}）`;
  }
  if (billingUnit === '张') {
    return `确认后将消耗 ${formatCreditAmount(unit)} IPE豆（${formatCreditAmount(unit)} IPE豆/张${resolutionHint}）`;
  }
  if (billingUnit === '次') {
    return `确认后将消耗 ${formatCreditAmount(unit)} IPE豆（${formatCreditAmount(unit)} IPE豆/次${resolutionHint}）`;
  }
  return `确认后将消耗 ${formatCreditAmount(unit)} IPE豆`;
}

export function creditBadgeLabel(navId, options = {}) {
  const meta = creditMetaForNav(navId);
  if (!meta) return null;
  const billingUnit = meta.billingUnit || '张';
  if (billingUnit === '免费') return '免费';
  if (billingUnit === '按步骤') return '按步骤';
  const unit = resolveCreditCost(meta, options);
  if (unit <= 0) return null;
  if (billingUnit === '张') return `${formatCreditAmount(unit)}IPE豆/张`;
  if (billingUnit === '次') return `${formatCreditAmount(unit)}IPE豆/次`;
  return `${formatCreditAmount(unit)}IPE豆`;
}

/**
 * 智能工具「立即生成」按钮右侧单价/合计（与商品设计 POD 批量合成一致，如 2/张、10/5张）
 */
export function buildStudioGenerateCostLabel(navId, { imageCount = 0, total, unit, resolution } = {}) {
  const meta = creditMetaForNav(navId);
  if (!meta) return null;
  const billingUnit = meta.billingUnit || '张';
  if (isNonBillableUnit(billingUnit)) return null;
  const resolvedUnit = unit != null && unit > 0
    ? unit
    : resolveCreditCost(meta, { resolution });
  if (resolvedUnit <= 0) return null;
  const unitSuffix = billingUnit === '次' ? '次' : '张';
  const count = Math.max(0, Number(imageCount) || 0);
  const resolvedTotal = total != null && total > 0
    ? total
    : (count > 0 ? resolvedUnit * count : 0);

  if (count > 0 && resolvedTotal > 0) {
    return `${formatCreditAmount(resolvedTotal)}/${count}${unitSuffix}`;
  }
  return `${formatCreditAmount(resolvedUnit)}/${unitSuffix}`;
}

function sortCatalogItems(items) {
  return [...items].sort((a, b) => {
    const costA = resolveCreditCost(a);
    const costB = resolveCreditCost(b);
    if (costA !== costB) return costB - costA;
    return String(a.label).localeCompare(String(b.label), 'zh-CN');
  });
}

function resolveBillingModule(navId, byNavId) {
  const refNavId = NAV_BILLING_REF[navId] || navId;
  return byNavId.get(refNavId) || null;
}

function buildCatalogRow(navId, toolMeta, byNavId) {
  const label = toolMeta?.label || navId;
  const billing = resolveBillingModule(navId, byNavId);
  const refNavId = NAV_BILLING_REF[navId] || navId;

  if (navId === 'ipeWorkflowTasks') {
    const wf = resolveBillingModule('ipeWorkflow', byNavId);
    return {
      navId,
      code: wf?.code || 'WORKFLOW_RUN',
      label,
      creditCost: 0,
      billingUnit: '按步骤',
    };
  }

  if (billing) {
    return {
      navId,
      code: billing.code,
      label,
      creditCost: resolveCreditCost(billing),
      billingUnit: billing.billingUnit || '张',
      supportsResolutionPricing: billing.supportsResolutionPricing === true,
      resolutionPrices: billing.resolutionPrices || undefined,
      refNavId: refNavId !== navId ? refNavId : undefined,
    };
  }

  return {
    navId,
    label,
    creditCost: 0,
    billingUnit: '免费',
  };
}

/**
 * 构建 IPE豆消耗说明完整目录（覆盖工作台全部功能入口）
 * @returns {{ title: string, items: Array }[]}
 */
export function buildCreditConsumptionCatalog(apiModules, {
  toolNavItems = {},
  navHubs = {},
  hubNavIds = new Set(),
} = {}) {
  const modules = apiModules?.length ? apiModules : getModuleCreditsList();
  const byNavId = new Map(modules.map((row) => [row.navId, row]));
  const wf = byNavId.get('ipeWorkflow');
  if (wf) {
    byNavId.set('ipeWorkflowTasks', wf);
  }

  const seen = new Set();
  const groups = [];

  Object.values(navHubs).forEach((hub) => {
    hub.sections?.forEach((section) => {
      const items = [];
      section.items?.forEach((navId) => {
        if (CREDIT_CATALOG_EXCLUDE_NAV_IDS.has(navId) || seen.has(navId)) return;
        const tool = toolNavItems[navId];
        if (!tool) return;
        seen.add(navId);
        items.push(buildCatalogRow(navId, tool, byNavId));
      });
      if (items.length) {
        groups.push({
          title: section.title,
          items: sortCatalogItems(items),
        });
      }
    });
  });

  const otherItems = [];
  Object.entries(toolNavItems).forEach(([navId, tool]) => {
    if (CREDIT_CATALOG_EXCLUDE_NAV_IDS.has(navId) || seen.has(navId) || hubNavIds.has(navId)) return;
    seen.add(navId);
    otherItems.push(buildCatalogRow(navId, tool, byNavId));
  });
  if (otherItems.length) {
    groups.push({
      title: '其他功能',
      items: sortCatalogItems(otherItems),
    });
  }

  return groups;
}

/** Admin IPE 定价：与消耗说明相同的模块分组 */
export function buildAdminModulePricingGroups(modules, {
  toolNavItems = {},
  navHubs = {},
  hubNavIds = new Set(),
} = {}) {
  if (!Array.isArray(modules) || modules.length === 0) return [];

  const apiModules = modules.map((row) => ({
    code: row.moduleCode,
    navId: row.navId,
    label: row.moduleName,
    creditCost: row.pointsPerCall,
    billingUnit: row.billingUnit,
    supportsResolutionPricing: row.supportsResolutionPricing,
    resolutionPrices: row.resolutionPrices,
  }));
  const byNavId = new Map(modules.map((row) => [row.navId, row]));
  const byCode = new Map(modules.map((row) => [row.moduleCode, row]));
  const assignedCodes = new Set();

  const resolveModule = (item) => {
    const fromNav = byNavId.get(item.navId);
    if (fromNav) return fromNav;
    if (item.code) return byCode.get(item.code) || null;
    return null;
  };

  const catalogGroups = buildCreditConsumptionCatalog(apiModules, {
    toolNavItems,
    navHubs,
    hubNavIds,
  });

  const groups = catalogGroups.map((group) => {
    const rows = [];
    group.items.forEach((item) => {
      const mod = resolveModule(item);
      if (mod && !assignedCodes.has(mod.moduleCode)) {
        assignedCodes.add(mod.moduleCode);
        rows.push(mod);
      }
    });
    return { title: group.title, modules: rows };
  }).filter((group) => group.modules.length > 0);

  const extras = modules
    .filter((row) => !assignedCodes.has(row.moduleCode))
    .sort((a, b) => String(a.moduleName).localeCompare(String(b.moduleName), 'zh-CN'));

  if (extras.length) {
    groups.push({ title: '其他模块', modules: extras });
  }

  return groups;
}
